import { homeCardsItems } from "@/common/fields/home-cards-items";
import { sidebarItems, sidebarItemsFlat } from "@/common/fields/sidebar-items";

export const verifyStrictPermission = (permissions = [], allowedPermission) => {
    if (!allowedPermission) return true;
    return permissions.some(
        (scope) =>
            scope === allowedPermission || scope === `${allowedPermission}_`
    );
};

// portal-sesion-y-candados-optimizacion: un grupo sin ningún ítem visible
// por permisos reales sale con candado, al final del menú, solo si el rol
// tiene el permiso `upgrade:*` del grupo (comparación estricta: `store:*`
// no implica `upgrade:Store`).
const _isLockedByPlan = (permissions, group) =>
    Boolean(group.upgrade) &&
    verifyStrictPermission(permissions, group.upgrade.permission);

const _lockedEntry = (group) => ({
    id: group.id,
    name: group.name,
    icon: group.icon,
    type: "item",
    feature: group.upgrade.feature,
    locked: true
});

export const generateSidebarWithNestedPermissions = (permissions = []) => {
    const locked = [];
    const visible = sidebarItems.reduce((result, item) => {
        if (item.type === "divider") {
            return [...result, item];
        }
        if (item.type === "item") {
            if (
                verifyStrictPermission(permissions, item.permission) &&
                !item.hide
            ) {
                return [...result, item];
            }
            return result;
        }
        const itemsChild = item.items.filter(
            (itemChild) =>
                verifyStrictPermission(permissions, itemChild.permission) &&
                !itemChild.hide
        );
        if (itemsChild.length) {
            return [
                ...result,
                {
                    ...item,
                    items: itemsChild
                }
            ];
        }
        if (_isLockedByPlan(permissions, item)) {
            locked.push(_lockedEntry(item));
        }
        return result;
    }, []);
    return [...visible, ...locked];
};

export const generateSidebarWithPlainPermissions = (permissions = []) => {
    const visible = sidebarItemsFlat.filter(
        (item) =>
            verifyStrictPermission(permissions, item.permission) && !item.hide
    );
    const locked = sidebarItems
        .filter(
            (group) =>
                group.type === "group" &&
                _isLockedByPlan(permissions, group) &&
                !visible.some((item) => item.groupId === group.id)
        )
        .map(_lockedEntry);
    return [...visible, ...locked];
};

export const generateHomeCards = (permissions = []) => {
    return generateHomeCardsCustom(permissions, homeCardsItems);
};

export const generateHomeCardsCustom = (
    permissions = [],
    homeCardsItemsCustom = []
) => {
    const seenUrls = new Set();
    const cardLinksAvailable = homeCardsItemsCustom.filter((item) => {
        if (!verifyStrictPermission(permissions, item.permission)) return false;
        if (seenUrls.has(item.url)) return false;
        seenUrls.add(item.url);
        return true;
    });

    let cardLinksActive = [...cardLinksAvailable];
    if (cardLinksAvailable.length >= 13) {
        cardLinksActive = cardLinksAvailable.filter((item) => item.isDefault);
    }
    return { cardLinksAvailable, cardLinksActive };
};
